import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Box } from '@mui/material';
import { LabelTypography } from './Typography/LabelTypography';

export const CustomInput = ({
  id,
  label,
  htmlTag,
  icon,
  children,
  direction,
  sx,
  sxStack,
  roleLabel = null,
}) => {
  return (
    <Stack sx={sxStack} direction={direction || 'column'} spacing={1}>
      <LabelTypography role={roleLabel} id={id} sx={sx} htmlFor={htmlTag}>
        <FontAwesomeIcon
          icon={icon}
          style={{
            position: 'relative',
            marginRight: '0.5em',
            marginLeft: '0.5em',
            paddingBottom: '0.1em',
            fontWeight: '500',
            fontSize: '1em',
            fontStyle: 'normal',
          }}
        />
        {label}
      </LabelTypography>
      <Box sx={{ paddingX: '1em' }}>{children}</Box>
    </Stack>
  );
};

export const CustomInputWithOutIcon = ({
  id,
  label,
  htmlTag,
  children,
  direction,
  styleLabel,
  sxStack,
  roleLabel = null,
}) => {
  const styles = {
    childrenContainer: {
      paddingX: '1em',
    },
  };
  return (
    <Stack sx={sxStack} direction={direction || 'column'} spacing={1}>
      <LabelTypography
        role={roleLabel}
        id={id}
        sx={styleLabel}
        htmlFor={htmlTag}
      >
        {label}
      </LabelTypography>
      <Box sx={styles.childrenContainer}>{children}</Box>
    </Stack>
  );
};
